class ResultsBar{
    constructor(el) {
        this.scope = el;
        this.scope.resultsBar = this;
        this.number = el.querySelector("[data-number]");
        this.ranges = el.querySelectorAll("[data-range]");
    }

    set(result){
        this.scope.classList.add("results-bar--transition");
        this.number.innerHTML = result;

        setTimeout(()=> {
            this.scope.style.setProperty('--result', result);
            this.getActive(result);
        },100)
    }

    getActive(result){
        this.ranges.forEach((range, i) =>{
            range.getAttribute("style").split(";").forEach(val=>{
                if(parseInt(val.split(" ")[val.split(" ").length-1]) <= result){
                    range.classList.add("results-bar__content__ranges__range--active");
                    if(i > 0) this.ranges[i-1].classList.remove("results-bar__content__ranges__range--active");
                }
            })
        })
    }

    clear(){
        this.ranges.forEach(range =>{
            range.classList.remove("results-bar__content__ranges__range--active");
        })
        this.scope.style.setProperty('--result', "");
        this.number.innerHTML = "";
        this.scope.classList.add("results-bar--transition");
    }
}

ControlBinders.register(`[data-results-bar]`, el => new ResultsBar(el));